import React, { Component } from "react";
import GlobalUserInput from "../../components/inputs/GlobalUserInput";
import MultiSelectInput from "../../components/inputs/MultiSelectInput";
import LoaderButton from "../../components/LoaderButton";
import HttpServices from "../../utils/Http.services";
import { translate } from "../../utils/useful";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import ButtonAnimated from "../../components/buttons/ButtonAnimated";
import FormViewer from "../../components/FormViewer";
class AddUserSearch extends Component {

  state = {

    headers: [
      { key: 'hub', type: 'GlobalUserInput', information: { label: '{{lang}}Hub', address: 'searchUser', filter: { appletHub: "{{appletHub}}" }, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Search hub', hint: '{{lang}}Select a hub you want to send an invitation for. If they approve, they will be connected your hub.', required: true } }
    ]
    // isLoadingRemove: false,
    // id: null,
    // index: null,
    // image: '',

  }

  // images=["001-man.svg",'011-woman.svg','012-woman.svg','019-man.svg','022-man.svg','025-man.svg','027-woman.svg','033-woman.svg','035-man.svg','038-man.svg','042-man.svg','043-woman.svg','049-woman.svg','050-woman.svg']

  // componentDidMount() {
  //   this.props.setTitle('Invite User')
  //   // this.changeImage()
  //   //  this.interval = setInterval(() => {
  //   //   this.changeImage()
  //   // }, 1500);
  // }


  componentWillUnmount() {
    clearInterval(this.interval)
  }

  changeImage = () => {
    let number = Math.floor(Math.random() * this.images.length - 1)
    if (this.images[number]) {
      let image = this.images[number]
      this.setState({ image })
    }
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }

  userSelected = (key, value) => {
    this.setState({ user: value })
  }

  groupsChanged = (key, value) => {
    this.setState({ groups: value })

  }

  invite = () => {
    let data = { user: this.state.user, groups: this.state.groups }
    if (this.state.user) {
      this.props.setData(data, () => {
        this.postValue()
      })
    } else {
      this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.userNotSelected', description: "{{lang}}errors.userIsRequired" })
    }
  }

  addMoreInfo = () => {
    let data = this.form.getForm()

    if (!data.hub) {
      return
    }

    // TO DO: check if hub is valid (Not previously connected and not virtual)

    this.props.setData(data, () => {
      this.props.changeStage('form')
    })
  }

  postValue = () => {
    // console.log("postValue")
    let data = this.props.initData


    this.setState({ errors: null })
    let page = this.props.page

    if (data) {
      let isEditing = data._id ? true : false
      let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
      data.page = this.props.page?.key
      this.setState({ isPostingData: true })

      if (page.postBody) {
        data = { ...data, ...page.postBody }
      }

      for (const [key, value] of Object.entries(data)) {
        if (/\{\{(.*?)\}\}/.test(value)) {

          if (this.props.variables) {
            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
          }
        }
      }

      // console.log(address)
      // console.log(data)


      HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
        this.setState({ isPostingData: false })
        // console.log(fetchError)
        if (fetchError) {
          this.setState({ errors: fetchError.errors })
          this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
          return
        }

        this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
        if (!isEditing) {
          this.props.userInvited(fetchResult.info)
        }

        if (isEditing) {
          // console.log("itemEdited")
          // console.log(data)
          if (fetchResult.info) {
            this.props.itemEdited(fetchResult.info, data._id)
          } else {
            this.props.itemEdited(data, data._id)
          }
        }
      })
    }

  }

  render() {
    return (
      <div className="pb-3" style={{}}>
        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '8px 14px', zIndex: 2, borderBottom: '1px solid #eee' }}>
          <div className='flexc' style={{}}>
            <button onClick={() => this.props.changePage('home')}>
              <img width={18} className='mrd-2 flexcc invert' src='/assets/icons/arrow-left-white.svg' alt="" />
            </button>
            <p className='text-normal text-semibold' style={{}}>{translate('Select a hub')}</p>
          </div>
          <ButtonAnimated
            iconwidth='24px'
            onClick={this.state.isLoadingPost ? () => { } : () => this.addMoreInfo()}
            title={translate('Next')}
            icon='/assets/icons/arrow-right-white.svg'
            textColor={this.props.colors?.textColor ?? '#fff'}
            invert={this.props.colors?.invertIcon}
            bg={this.props.colors?.background ?? 'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
            // textColor={'#007aff'}
            // invert={false}
            // bg={this.props.colors?.background ? '#000' : '#fff'}

            isLoading={this.state.isLoadingPost}
          />
        </div>
        {/* <div className="d-flex flex-column py-2  px-3 " style={{ background: 'linear-gradient(to  left , #677dc4, #877cc4)', position: 'sticky', top: 0, zIndex: 1 }}>
          <p className="mt-1 text-big text-bold white">{translate("Invite User")}</p>
        </div> */}
        {/* <p className="pt-3  px-3 text-smaller pb-3" style={{ backgroundColor: '#f2f6f8', color: '#203040' }}>{translate("While-Inviting-users")}</p> */}

        <div className="px-3 mt-3">


          <FormViewer ref={el => this.form = el} initData={this.props.initData} headers={this.state.headers} formClass="bordered-form" inputClass={'bordered-input'} params={this.props.params} variables={this.props.variables} nopadding={true} />



          {/* <p className="px-1 pt-3 weight-500 font-size-14 mb-2 required" >{translate("Hub")}</p>
          <div className="flexcc w-100 bordered-input" >
            <div className="flex-2 w-100 position-relative">
              <GlobalUserInput changeValue={this.userSelected} data={this.state.user} variables={this.props.variables} />
            </div>
          </div>

          <p className="text-smaller px-1 mt-1" style={{ color: '#777' }}>{translate("Select a hub you want to send an invitation for. If they approve, they will be connected your hub.")}</p> */}



          {/* <p className="px-1 mt-3 weight-500 font-size-14 mb-2" >{translate("Groups")}</p>

          <div className="flexcc w-100 bordered-input" >
            <div className="flex-2 w-100  position-relative">
              <MultiSelectInput variables={this.props.variables} data={this.state.groups} changeValue={this.groupsChanged} header={{ key: '', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { hub: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } }} />
            </div>
          </div>

          <p className="text-smaller px-1 mt-1" style={{ color: '#9ab' }}>{translate("This field is optional and can be used for fast assignment of the user of the groups")}</p> */}


          <div className="w-100 flexc mt-4" style={{ justifyContent: 'space-around' }}>

            {/* <LoaderButton
              onClick={this.invite}
              isLoading={this.state.isPostingData}
              text={translate("invite")}
              type={"Oval"}
              className="w-100"
              buttonClassName="text-small py-2 px-3 white w-100 mrd-1 text-bold w-100"
              buttonStyle={{ background: 'linear-gradient(to  left , #677dc4, #877cc4)', with: '100%', color: '#fff', borderRadius: '4px' }}
              width={40}
              height={40}
              color={'#fff'}
            /> */}

            {/* <button onClick={() => this.invite()} className="text-small py-2 px-3 white w-100 mrd-1 text-bold" style={{ background: 'linear-gradient(to  left , #677dc4, #877cc4)', borderRadius: '4px' }}><p>{translate("invite")}</p></button> */}

            {/* <button onClick={()=>this.invite()} className="text-small py-2 px-3 white w-100 mrd-1 text-bold" style={{background:'linear-gradient(to  left , #009680, #007C81)',borderRadius:'20px'}}><p>{translate("invite")}</p></button> */}
            {/* <button onClick={() => this.addMoreInfo()} className="text-small py-2 px-3  w-100 mld-1" style={{ background: 'linear-gradient(to  left , #e2e8ea, #e8eaf0)', borderRadius: '4px' }}><p>{translate("Add more Info")}</p></button> */}
          </div>
        </div>

        {/* <button onClick={() => this.props.lastStage()} className="text-small py-2 px-3 white w-100 mt-2 " style={{ color: '#789', borderRadius: '20px' }}><p>{translate("back one stage?")}</p></button> */}



      </div>

    );
  }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, { forwardRef: true }
)(AddUserSearch);
